import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import { mapRequestsFromCrud } from '../../services/mapping/mapRequestFromCrud'
import { IChildrenRequestsActionParams, IOnboardingState } from '../models'

export const getChildrenRequestsPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IChildrenRequestsActionParams }>
) => {
  const { meta } = action

  state.childrenRequestsData.meta = meta
  state.childrenRequestsData.status = RequestStatus.PENDING
  state.childrenRequestsData.message = ''
}

export const getChildrenRequestsRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IChildrenRequestsActionParams }>
) => {
  const { meta } = action

  state.childrenRequestsData.meta = meta
  state.childrenRequestsData.status = RequestStatus.REJECTED
  state.childrenRequestsData.message = action.payload as string
}

export const getChildrenRequestsFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IChildrenRequestsActionParams }>
) => {
  const { meta, payload } = action

  state.childrenRequestsData.meta = meta
  state.childrenRequestsData.status = RequestStatus.FULFILLED
  state.childrenRequestsData.message = ''
  if (payload) {
    state.childrenRequestsData.data = mapRequestsFromCrud(payload.childrenRequests)
  }
}
